import { sortBy } from "./utility";
import timetable from '@/timetable.js';
import filters from "./filters";

export default function findMatchingThings(searchText) {
  if (!searchText)
    return [];

  var searchKeys = ['StudentPreferredFormal', 'StudentPreferred', 'StudentSurname', 'SchoolStaffCode', 'StaffOccupEmail', 'StaffPreferredName', 'StaffSurname', 'code', 'name', 'ROOM', 'CODE', 'ClassDescription', 'StaffID', 'StudentID'];

  var searchTargets = [timetable.students, timetable.teachers, timetable.subjects, timetable.rooms, timetable.yard_duty_locations].reduce((prev, curr) => prev.concat(Object.values(curr).sort(sortBy(thing => thing.getName ? thing.getName() : thing))), []);
  searchTargets = searchTargets.map(searchTarget => ({
    'name': searchKeys.map(key => searchTarget[key]).join(' '),
    'item': searchTarget
  }));

  var parts = searchText.split(' ');

  parts = parts.filter(p => Object.keys(filters).every(filterName => {
    if (p.indexOf(filterName + ':') == 0) {
      var arg = p.split(':')[1];
      searchTargets = searchTargets.filter(thing => filters[filterName](thing.item, arg));
      return false;
    }
    return true;
  })
  );


  var newSearchText = parts.join(' ');

  var matchingThings = searchTargets;
  if (newSearchText) {
    var words = newSearchText.split(' ').map(w => w.toLowerCase());
    var lowerSearch = newSearchText.toLowerCase();
    matchingThings = [];
    searchTargets.forEach(searchTarget => {
      // hoist the per-target lowercase + split out of the per-word loop
      var target_name = searchTarget.name.toLowerCase();
      var target_words = target_name.split(' ');
      var score = 0;
      words.forEach(word => {
        if (word === target_name)
          score += 3;
        else if (target_words.some(target_name_word => target_name_word.indexOf(word) === 0))
          score += 2;
        else if (target_name.indexOf(word) !== -1)
          score += 1;
      });
      if (target_name.indexOf(lowerSearch) !== -1)
        score += 5;
      if (score === 0)
        return;
      matchingThings.push({ 'item': searchTarget.item, 'score': score });
    });
    matchingThings.sort(sortBy(matchingThing => matchingThing.score, { reverse: true }));
  }
  matchingThings = matchingThings.map(x => x.item);
  return matchingThings;
}
